module.exports = __webpack_public_path__ + "fonts/Fortescue-Regular.801c89abc3a08c790a7058ed9fd81c62.woff2";